<template>
  <div
    id="page-wrapper"
    class="wrap-container wrap-container--has-margin-top wrap-container--has-margin-bottom error-page"
    role="main"
  >
    <div class="error-page__wrapper row">
      <div class="error-page__content-wrapper col-12_md-8_lg-6">
        <div
          v-if="prefix || isEditable"
          v-edit="'Prefix'"
          class="error-page__prefix"
        >
          {{ prefix }}
        </div>
        <h1
          v-if="title || isEditable"
          v-edit="'Title'"
          class="error-page__heading"
        >
          {{ title }}
        </h1>
        <div
          v-if="content || isEditable"
          v-edit="'Content'"
          class="error-page__content"
          v-html="$options.filters.stringify(content)"
        />
        <div class="error-page__illustrative-links">
          <illustrative-links-block
            v-for="(link, index) in illustrativeLinks"
            :key="index"
            v-bind="link"
            :style="{ animationDelay: index * (1 / 10) + 's' }"
            class="fade-in-up"
            @click.native="trackIllustrativeLinkClick(link.text)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import track from "@/analytics/dataLayerErrorPage"
import "#/Illustrative/Cart"
import "#/Illustrative/Recipe"
import "#/Illustrative/Location"
import "#/Illustrative/AccountBalance"

export default {
  name: "ErrorPage",
  props: {
    prefix: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    content: {
      type: [Array, String],
      default: () => []
    },
    illustrativeLinks: {
      type: Array,
      default () {
        return []
      }
    },
    errorCode: {
      type: Number,
      default: 0
    }
  },
  mounted () {
    track.pageLoad(this.errorCode)
  },
  methods: {
    trackIllustrativeLinkClick (text) {
      track.illustrativeLinkClick(text)
    }
  }
}
</script>

<style lang="scss">
.error-page {
  @include media-breakpoint-up(md) {
    background: none;
  }

  &.wrap-container {
    padding: 0;

    @include media-breakpoint-up(md) {
      padding: 0 1.5rem;
    }
  }

  &__heading {
    @include font(rubrik, 7, "black");

    margin: 0.5rem 0;
    padding: 0 2rem;

    @include media-breakpoint-up(md) {
      padding: 0;
    }
  }

  &__prefix {
    @include font(hand, 2, "normal");

    color: $color-red;
    padding: 0 2rem;

    @include media-breakpoint-up(md) {
      padding: 0;
    }
  }

  &__wrapper {
    position: relative;
    border-radius: 4px;
    background-color: $color-white;
  }

  &__image-wrapper {
    position: relative;
  }

  &__content {
    @include font(text, 5, "normal");

    p {
      margin: 0.5rem 0;
      padding: 0 2rem;

      @include media-breakpoint-up(md) {
        padding: 0;
      }
    }
  }

  &__content-wrapper {
    padding: 24px;
    text-align: center;
    margin: 3rem auto 4rem;

    @include media-breakpoint-up(lg) {
      margin: 4rem auto;
    }
  }

  .epi-background-container,
  .empty-image-placeholder {
    padding-bottom: 74.67%;
    background-size: cover;

    @include media-breakpoint-up(md) {
      padding-bottom: 66.67%;
    }

    @include media-breakpoint-up(lg) {
      padding-bottom: 58.59%;
    }

    @include media-breakpoint-up(xl) {
      border-radius: 4px;
      padding-bottom: 58.44%;
    }
  }

  .epi-background-container {
    &.small {
      margin: 0 -1rem;

      @include media-breakpoint-up(md) {
        margin: 0;
      }
    }
  }

  .error-page__illustrative-links {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 0.5rem;

    @include media-breakpoint-up(lg) {
      margin-left: -4rem;
      margin-right: -4rem;
    }

    .illustrative-links {
      &__icon-wrapper {
        height: 5rem;
        width: 5rem;
        transition: all 0.2s ease-in-out;
        margin-bottom: 1rem;

        .svg-icon {
          height: 3rem;
          width: 3rem;
        }

        @include media-breakpoint-up(lg) {
          height: 7rem;
          width: 7rem;

          .svg-icon {
            height: 4rem;
            width: 4rem;
          }
        }
      }

      &__block {
        flex: 1 1 50%;
        margin-top: 2rem;

        @include media-breakpoint-up(md) {
          flex-basis: 25%;
        }

        &:hover .illustrative-links__icon-wrapper {
          transform: scale(1.1);
        }
      }
    }
  }
}
</style>
